import React, { useEffect, useRef } from "react";
import classes from "./Intro.module.css";
import image from "../../../assets/images/sustainable-farm.jpg";
import Container from "../../UI/Container/Container";
import { gsap } from "gsap";

const Intro = (props) => {
  const partOne = useRef(0);
  const partTwo = useRef(0);
  const partThree = useRef(0);

  useEffect(() => {
    const timeline = gsap.timeline();

    timeline.to(partOne.current, {
      opacity: 1,
      duration: .75,
      ease: "sine.out",
      delay: 1,
    });
    timeline.to(partTwo.current, {
      opacity: 1,
      duration: .75,
      ease: "sine.out",
    });
    timeline.to(partThree.current, {
      opacity: 1,
      duration: .75,
      ease: "sine.out",
    });
  });

  return (
    <div className={classes.Intro}>
      <img src={image} alt="Students working on the Farm" />
      <div className={classes.Overlay}>
        <Container>
          <div className={classes.Content}>
            <h1>
              <span ref={partOne}>Our </span>
              <span ref={partTwo}>Sustainable </span>
              <span ref={partThree}>Leadership</span>
            </h1>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Intro;
